import '@vfde-brix/button-tiles/dist/styles.css';
import { createButtonTilesComponent } from '@vfde-brix/button-tiles';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';
import { createComponents } from '../../utils/initComponents';

createComponents('brix-button-tiles', createButtonTilesComponent, NO_PATTERN_BUSINESS_LOGIC, element => element);
